import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from '../generic.service';

export interface RoiCalculationRequest {
  universityId: string;
  level: string; // "UG" or "PG"
  programType?: string;
  schoolName?: string;
  courseName?: string;
  studentStatus: string;
  livingSituation: string;
  scholarshipAmount: number;
  suggestLoan?: boolean;
}

export interface CurrencyValue {
  local: string;
  inr: string;
  rawLocal: number;
  rawINR: number;
}

export interface LoanGuidance {
  tier: string;
  shortSummary: string;
  bulletPoints: string[];
}

export interface ReturnsProjections {
  breakEvenYears: number;
  fiveYearRoiPercent: number;
  tenYearRoiPercent: number;
  fiveYearNetSavings: CurrencyValue;
  tenYearNetSavings: CurrencyValue;
}

export interface ScholarshipOpportunity {
  name: string;
  link?: string;
  fundingType?: string;
  amount?: string;
}

export interface RoiCalculationResponse {
  investment: {
    tuition: CurrencyValue;
    livingCosts: CurrencyValue;
    scholarships: CurrencyValue;
    totalInvestment: CurrencyValue;
  };
  outlook: {
    employedPercentage: number;
    startingSalary: CurrencyValue;
    afterTaxSalary: CurrencyValue;
    year1NetSavings: CurrencyValue;
    topIndustries: string;
  };
  returns: ReturnsProjections;
  recommendation?: LoanGuidance | null;
  verdict: string;
  scholarshipOpportunities?: ScholarshipOpportunity[];

  // Variant B (For PG only, data-anchored Year 5 salary outcome compounding)
  returnsVariantB?: ReturnsProjections;
  recommendationVariantB?: LoanGuidance | null;
  verdictVariantB?: string;
}

@Injectable({
  providedIn: 'root'
})
export class RoiCalculatorService {
  constructor(private genericService: GenericService) {}

  calculateRoi(request: RoiCalculationRequest): Observable<RoiCalculationResponse> {
    return this.genericService.post<RoiCalculationResponse>('roi-calculator/calculate', request);
  }

  searchRoiUniversities(searchText: string, level: string): Observable<any[]> {
    const url = searchText ? `roi-calculator/search-universities/${level}/${searchText}` : `roi-calculator/search-universities/${level}`;
    return this.genericService.get<any[]>(url);
  }

  getRoiPgCourses(universityId: string): Observable<any> {
    return this.genericService.get<any>(`roi-calculator/courses/${universityId}`);
  }
}
